import { useEffect, useRef, useState } from "react";

export function useElementsObserver(elementIds: string[]) {
    const observer = useRef<IntersectionObserver>();
    const [activeElementIds, setActiveElementIds] = useState<Record<string, boolean>>({});

    const query = elementIds.map(id => `#${id}`).join(", ");

    useEffect(() => {
        const handleObsever: IntersectionObserverCallback = entries => {
            setActiveElementIds(state => ({
                ...state,
                ...entries.reduce(
                    (acc, entry) => ({
                        ...acc,
                        [entry.target.id]: entry.isIntersecting
                    }),
                    {}
                )
            }));
        };

        observer.current = new IntersectionObserver(handleObsever, {
            rootMargin: "-25% 0% -25% 0%"
        });

        const elements = document.querySelectorAll(query);
        elements.forEach(element => observer.current?.observe(element));

        return () => observer.current?.disconnect();
    }, [query]);

    return {
        activeElementIds: Object.entries(activeElementIds)
            .filter(([, isIntersecting]) => isIntersecting)
            .map(([id]) => id)
    };
}
